import fromExponential from 'from-exponential';
import thousands from 'thousands';
import toPrecision from './to-precision';
/**
 * @param {number|string} num
 * @param {number} [precision]
 * @param {PRECISION_SETTING} [precisionSetting]
 * @param {ROUNDING_MODE} [roundingMode]
 * @param {string} [thousandsSeparator]
 * @return {string}
 */

export default function prettyNum(num) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      precision = _ref.precision,
      precisionSetting = _ref.precisionSetting,
      roundingMode = _ref.roundingMode,
      thousandsSeparator = _ref.thousandsSeparator;

  // remove exponential notation
  num = fromExponential(num); // reduce precision

  num = toPrecision(num, precision, {
    precisionSetting: precisionSetting,
    roundingMode: roundingMode
  });

  if (thousandsSeparator) {
    num = thousands(num, thousandsSeparator);
  }

  return num;
}